import {Component, OnDestroy, OnInit} from '@angular/core';
import {TasksService} from '../tasks.service';
import {TasksModel} from '../models/tasks.model';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {AnalyticsService} from '../../../services/analytics.service';
import {environment} from '../../../../environments/environment';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-tasks-page',
    templateUrl: './tasks-list.component.html',
    styleUrls: ['./tasks-list.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})

export class TasksListComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];

    tasksList: TasksModel[] = null;
    tasksListValid = false;
    tasksListPromise: Promise<TasksModel[]> = null;

    isHideCompleted = false;
    theme = 'default';

    constructor(
        private tasksService: TasksService,
        private analytics: AnalyticsService,
        private event: EventsService,
        public userService: UserService
    ) {
        this.subscriptions.push(
            this.event.subscribe('login', () => this.tasksListValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('review.updateMyReviewReportFeedbackStatus', () => this.tasksListValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => this.tasksListValid = false)
        );
    }

    ngOnInit() {
        this.theme = environment.theme;
    }

    ionViewWillEnter() {
        if (this.tasksList === null || !this.tasksListValid) {
            this.tasksListPromise = this.tasksService.getMyTasksList();
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('My Tasks');

        if (this.tasksList === null || !this.tasksListValid) {
            this.tasksListPromise.then(data => {
                this.tasksList = data;
                this.tasksListValid = true;
            });
        }
    }

    runTask(task: TasksModel) {
        this.tasksService.runTask(task);
    }

    changeStatus(task: TasksModel) {
        this.tasksService.updateTaskStatus(task);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
